export default __webpack_public_path__ + "static/media/VolvoNovum-Light.9d030bc2.eot";